import { render, staticRenderFns } from "./ServiceObjectMaintenanceNoteOperations.vue?vue&type=template&id=4dc58fed&"
import script from "./ServiceObjectMaintenanceNoteOperations.vue?vue&type=script&lang=js&"
export * from "./ServiceObjectMaintenanceNoteOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QField,QTable,QTh,QTr,QTd,QBtn,QTooltip,QCardSection} from 'quasar'
component.options.components = Object.assign({QField,QTable,QTh,QTr,QTd,QBtn,QTooltip,QCardSection}, component.options.components || {})
